import i18n from "./i18n";

export const validateEIN = (value: string) => {
  if (!value) return;
  return !/^[0-9]{2}-[0-9]{7}$/i.test(value) ? i18n.t("Should be in the format of 12-3456789") : undefined;
};
